export function demoPopup(windowEl) {
    if (!windowEl) {
        return;
    }
    var openEls = document.querySelectorAll('.demo-window-trigger');
    if (!openEls || (openEls && openEls.length <= 0)) {
        return;
    }
    var config = {
        openCls: 'visible'
    };
    openEls.forEach(function (el) {
        el.addEventListener('click', function () {
            windowEl.classList.add(config.openCls);
        });
    });
    var closeEls = [windowEl.querySelector('#closePopUp'), windowEl];
    var handleClose = function (evt) {
        if (closeEls.some(function (el) { return evt.target === el; })) {
            windowEl.classList.remove(config.openCls);
        }
    };
    closeEls.forEach(function (el) {
        if (el) {
            el.addEventListener('click', handleClose);
        }
    });
}
